import React from 'react'

const PsJoystick = () => {
  return (
    <div style={{position: "fixed"}}>PsJoystick</div>
  )
}

export default PsJoystick